export const testimonials = [
  {
    id: 1,
    name: "Sarah",
    location: "Temecula, CA",
    rating: 5,
    text: "Jose Castillo is very professional and does great Quality work. The painting and other construction services he provided were done with the utmost care and attention to detail. I also appreciate that he is responsive and always on time. I would highly recommend using Castillo Paint Inc.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20middle%20aged%20Hispanic%20woman%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20neutral%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-01&orientation=squarish",
  },
  {
    id: 2,
    name: "Gloria",
    location: "Norco, CA",
    rating: 5,
    text: "Hi Jose: Thank you for your professionalism and excellent service. My daughter returns on Friday and as you can see we have many challenges. She has inspection planned by the City of Norco, after which she will be planning projects. I am going to recommend to her that she contact you. It would be based on her plan. Again thank you, I was very satisfied with Marin's work",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20businessman%20in%20his%20forties%2C%20confident%20smile%2C%20soft%20natural%20lighting%2C%20neutral%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-02&orientation=squarish",
  },
  {
    id: 3,
    name: "Danny",
    location: "Moreno Valley, CA",
    rating: 5,
    text: "I hired 'Castillo Painting Inc' in painting the entire exterior of my home as well as patching a large drywall section in my kitchen ceiling. He was very professional, friendly and thorough. His work speaks for itself. I will definitely be hiring for any of my future home projects.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Caucasian%20woman%20in%20her%20thirties%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20neutral%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-03&orientation=squarish",
  },
  {
    id: 4,
    name: "David Martinez",
    location: "San Bernardino, CA",
    rating: 5,
    text: "The team pressure washed our entire property and then painted the exterior. The transformation was dramatic. Fair pricing, great communication, and top-notch work.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Hispanic%20man%20in%20his%20forties%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20neutral%20background%2C%20portrait%20photography&width=100&height=100&seq=avatar-04&orientation=squarish",
  },
];